import { useState } from 'react';
import { seoContent } from '@/mocks/seoContent';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-800 text-xs font-semibold rounded-full tracking-wide uppercase mb-4">
            Common Questions
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Frequently Asked Questions About the OOPBuy Spreadsheet
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            Find answers to the most common questions about the OOPBuy Spreadsheet system, how it works, and how to get the most out of it.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {seoContent.faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/50"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-5 md:px-6 py-4 md:py-5 flex items-center justify-between text-left cursor-pointer hover:bg-background-50/80 transition-colors duration-200"
              >
                <h3 className="text-foreground-950 font-heading text-base md:text-lg font-semibold pr-4">
                  {faq.question}
                </h3>
                <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                  openIndex === index
                    ? 'bg-accent-500 text-background-50 rotate-45'
                    : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 pb-5 px-5 md:px-6' : 'max-h-0'
                }`}
              >
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-foreground-500 text-sm">
            Still have questions?{' '}
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-accent-700 hover:text-accent-800 font-medium underline underline-offset-2 cursor-pointer"
            >
              Visit the main platform
            </a>
            {' '}for more information.
          </p>
        </div>
      </div>
    </section>
  );
}